import axios from "../axios";
import auth from "./auth";

const subjectGrade = {
  getGrade() {
    return new Promise((resolve, reject) => {
      axios
        .get("/grades")
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
  getSubjects() {
    return new Promise((resolve, reject) => {
      axios
        .get("/subjects")
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
  getLangauge() {
    return new Promise((resolve, reject) => {
      axios
        .get("/languages")
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
  getSearchTeacher(data) {
    return new Promise((resolve, reject) => {
      
      axios
        .post("/adverts/teacher-by-level-subject", data)
        .then((response) => resolve(response))
        .catch((error) => {
          reject(error);
          error?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // 👀 Vue de la fiche (statistiques v2, tour 46, helper/ficheView.js)
  // 📈 Visite comptée pour l'entonnoir de l'admin (tour 68, B8) : « site » ou « devenir_prof »
  recordVisit(page) {
    return axios.post("/visits", { page });
  },
  recordAdvertView(id, source) {
    return axios.post(`/adverts/${encodeURIComponent(id)}/view`, source ? { source } : {});
  },
  getAdvertById(id) {
    return new Promise((resolve, reject) => {
      
      axios
        .get("/adverts", id)
        .then((response) => resolve(response))
        .catch((error) => {
          reject(error);
          error?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  getTeacherById(id) {
    return new Promise((resolve, reject) => {
      axios
        .get("/teachers", id)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
  // ----------------- Home page api's and unAuthorized api's
  getPopularAdverts() {
    return new Promise((resolve, reject) => {
      axios
        .get("/get-popular-subjects")
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
  // 🏠 Accueil : { online: 1 } profs en ligne seulement, { top: 6 } les 6 mieux notés
  getAllAdverts(params) {
    return new Promise((resolve, reject) => {
      axios
        .query("/adverts", { params })
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
  // 🏠 « Explorer les cours » : { top: 6 } les 6 mieux notés de la matière seulement
  getAllAdvertsById(id, params) {
    return new Promise((resolve, reject) => {
      axios
        .query(`adverts/get-adverts-by-subject/${id}`, { params })
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
  getTestimonial() {
    return new Promise((resolve, reject) => {
      axios
        .get("/get-five-top-teacher")
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
  sendContactEmail(data) {
    return new Promise((resolve, reject) => {
      axios
        .post("/contact-us", data)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
  manageNotification(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/read-notification/${id}`)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  manageNotificationViewed(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/viewed-notification/${id}`)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  fetchTeacherCount() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/get-teacher-count`)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
};

export default subjectGrade;
